import { Severity } from "../../components/toast";
import { ADD_MESSAGE, REMOVE_MESSAGE } from "../actions/messagesActions";

export interface IMessage {
  text: string;
  severity: Severity;
}

export interface IMessagesState {
  messages: IMessage[];
}

const initialState: IMessage[] = [];

const messagesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return state.concat(action.payload.message);
    case REMOVE_MESSAGE:
      return state.filter((message) => message.text !== action.payload.message.text);
    default:
      return state;
  }
};

export default messagesReducer;
